// extracted by mini-css-extract-plugin
module.exports = {"root":"QuoteSection-module--root--2Norh","text":"QuoteSection-module--text--3uXqq","citation":"QuoteSection-module--citation--31xPO"};